import { render, staticRenderFns } from "./OnboardingGender.vue?vue&type=template&id=ae79ef24&scoped=true&"
import script from "./OnboardingGender.vue?vue&type=script&lang=js&"
export * from "./OnboardingGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae79ef24",
  null
  
)

export default component.exports